import React from 'react';
import PropTypes from 'prop-types';

import { Paragraph } from 'components/core/Typography';

export function PaginationSummary({
	page,
	totalPages,
	totalItems
}) {
	return (
		<Paragraph className="pagination-summary">
			Page <span className="current-page-num">{page}</span> of {totalPages}
			{' '}
			<span className="total-listings-count">
				({totalItems} results found)
			</span>
		</Paragraph>
	);
}

PaginationSummary.propTypes = {
	page: PropTypes.number,
	totalItems: PropTypes.number,
	totalPages: PropTypes.number
};

PaginationSummary.defaultProps = {
	page: 0,
	totalItems: 0,
	totalPages: 0
};

export default PaginationSummary;
